module.exports = __webpack_public_path__ + "static/media/Bigdata.88178f7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/Bigdata.mp4
// module id = uijB
// module chunks = 15